import {Component, OnDestroy, OnInit} from '@angular/core';
import {ProjectConstants} from '../../../project-constants';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {Subscription} from 'rxjs';
import {ActivatedRoute, Router} from '@angular/router';
import * as toastr from 'toastr';
import {ContractTypeModel} from '../../../../models/ContractTypeModel';
import {ContractTypeService} from '../../../general-services/service-contract-type/contract-type.service';

@Component({
  selector: 'app-edit-contract-type-anagraf',
  templateUrl: './edit-contract-type-anagraf.component.html',
  styleUrls: ['./edit-contract-type-anagraf.component.scss']
})
export class EditContractTypeAnagrafComponent extends ProjectConstants implements OnInit, OnDestroy {

  contractType: ContractTypeModel;
  formValidator: FormGroup;
  formBuilder: FormBuilder;

  parameterSubscribe: Subscription;
  saveSubscribe: Subscription;
  submitted = false;

  id: number;
  contractTypeCod: string;
  description: string;
  contractTypeJson: any;

  constructor(private route: ActivatedRoute, private router: Router,
              private contractTypeService: ContractTypeService, private _Activatedroute: ActivatedRoute) {
    super();

    this.parameterSubscribe = this.route
      .queryParams
      .subscribe(params => {
        this.contractTypeJson = params['row'];
      });

    this.contractType = new ContractTypeModel();

    this.formBuilder = new FormBuilder();

    this.formValidator = this.formBuilder.group({
      cod: [this.contractType.cod, [Validators.required]],
      description: [this.contractType.description, [Validators.required]],
      startNumAnnoMese: [this.contractType.startNumAnnoMese, [Validators.required]],
      endNumAnnoMese: [this.contractType.endNumAnnoMese, [Validators.required]]
    });

    this.contractType = JSON.parse(this.contractTypeJson) as ContractTypeModel;

    this.formValidator.patchValue({
      cod: this.contractType ? this.contractType.cod : ''
    });

    this.formValidator.patchValue({
      description: this.contractType ? this.contractType.description : ''
    });

    let startDate = null;
    let endDate = null;
    if (this.contractType) {
      const startYear = Number(this.contractType.startNumAnnoMese.toString().substring(0, 4));
      const startMonth = Number(this.contractType.startNumAnnoMese.toString().substring(4, 6));
      const startDay = Number(this.contractType.startNumAnnoMese.toString().substring(6, 8));
      startDate =  new Date(startYear, startMonth, startDay);

      const endYear = Number(this.contractType.endNumAnnoMese.toString().substring(0, 4));
      const endMonth = Number(this.contractType.endNumAnnoMese.toString().substring(4, 6));
      const endDay = Number(this.contractType.endNumAnnoMese.toString().substring(6, 8));
      endDate =  new Date(endYear, endMonth, endDay);
    }


    this.formValidator.patchValue({
      startNumAnnoMese: startDate ? startDate : ''
    });

    this.formValidator.patchValue({
      endNumAnnoMese: endDate ? endDate : ''
    });

    _Activatedroute.params.subscribe(params => {
      this.id = params['id'];
      this.contractTypeCod = params['cod'];
      this.description = params['description'];
    });
  }

  ngOnInit() {
  }

  cancel(event: any) {
    event.preventDefault();
    this.router.navigate([this.LINKS.MASTER_DATA + this.LINKS.ANAGRAPH.CONTRACT_TYPE_ANAGRF]);
  }

  edit() {
    let startYearMonth = null;
    let endYearMonth = null;
    if (this.formValidator.valid) {
      event.preventDefault();
      startYearMonth = new Date(this.formValidator.value.startNumAnnoMese);
      endYearMonth = new Date(this.formValidator.value.endNumAnnoMese);
      const startYearMonthFinal = startYearMonth.getFullYear() + ('0' + (startYearMonth.getMonth() + 1)).slice(-2);
      const endYearMonthFinal = endYearMonth.getFullYear() + ('0' + (endYearMonth.getMonth() + 1)).slice(-2);
      if ( startYearMonthFinal <= endYearMonthFinal) {
        this.contractType.cod = this.formValidator.value.cod;
        this.contractType.description = this.formValidator.value.description;
        this.contractType.startNumAnnoMese = startYearMonthFinal;
        this.contractType.endNumAnnoMese = endYearMonthFinal;
        this.saveSubscribe = this.contractTypeService.update(this.contractTypeService.baseUrl, this.contractType).subscribe(
          (result: any) => {
            if (result === -1) {
              toastr.options.timeout = 5000;
              toastr.warning('Duplicate item, Contract Type cod already exists', 'Warning');
            }else if (result === -2) {
              toastr.options.timeout = 5000;
              toastr.warning('Elemenet cannot be updated', 'Warning');
            } else {
              this.router.navigate([this.LINKS.MASTER_DATA + this.LINKS.ANAGRAPH.CONTRACT_TYPE_ANAGRF]);
            }
          });

      } else {
        toastr.warning('Please check Dates before continue', 'Warning');
      }
    }
  }

  ngOnDestroy(): void {
    if (this.saveSubscribe) {
      this.saveSubscribe.unsubscribe();
    }
  }
}
